import configureStore from 'utils/redux/configureStore';
import rootReducer from './reducers';
import rootSaga from './sagas';

export default () => {
  const store = configureStore(rootReducer, rootSaga);

  // Make reducers hot reloadable, see http://mxs.is/googmo
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./reducers').default;
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
};



// WEBPACK FOOTER //
// ./src/modules/bucket/store.js